import React from "react";

export default function EditInvoice() {
  return <div>EditInvoice</div>;
}
